let obj = {
    locales: {},
    country:""
}
export default obj;